export default function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/sum.js
// module id = 807
// module chunks = 0